import styles from "./styles.module.css";
import imgCard from "../../images/email-em-analise.png";
import { Button } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ChatAssincrono from "../../components/ChatAssincrono";
import styled from "styled-components";
import { buscaConversa } from "../../services/api-planejamento-tributario.service";
import { LoginContext } from "../../config/Context/LoginContext";

const ButtonContact = styled.button`
  all: unset;
  background-color: #ffa500;
  border-radius: 8px;
  color: #fff;
  transition: all 0.2s ease-in-out;
  padding: 10px;
  cursor: pointer;
  position: relative;

  &:hover {
    transform: scale(1.1);
  }

  ${(props) =>
    props.newMsg &&
    `
    &::before {
      position: absolute;
      font-size: 0.8rem;
      content: "!";
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 100%;
      background-color: red;
      top: -7px;
      right: -5px;
      text-align: center;
      animation: pulse 1s infinite;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    }
    `}

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const AguardandoAssinatura = () => {
  const [modalChat, setModalChat] = useState(false);
  const [buttonContact, setButtonContact] = useState({
    label: "DÚVIDAS? FALE CONOSCO",
    newMsg: false,
  });
  const { dadosLogin } = useContext(LoginContext);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const existContact = params.get("contact");

    if (existContact) {
      setModalChat(true);
    }

    const verificaMensagens = async () => {
      try {
        const responseChat = await buscaConversa("JURIDICO", dadosLogin.idUsuario);
        const typeLastMsg = responseChat.objConversaUsuario.at(-1).tipoContato;
        if (typeLastMsg === "usuario_interno") {
          setButtonContact({
            label: "Existem novas mensagens",
            newMsg: true,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    verificaMensagens();
  }, []);

  const handleCloseModalChat = (value) => {
    setModalChat(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <h2 className={styles.title}>Contrato Disponível</h2>
        <img
          src={imgCard}
          alt="Pessoa assinando contrato"
          className={styles.img}
        />
        <div className={styles.body}>
          <p>
            <strong>
              Parabéns! Seu cadastro foi aprovado e seu contrato já está
              disponível para assinatura.
            </strong>
          </p>
          <br />
          <p>
            Acesse seu <strong>e-mail</strong> e realize a{" "}
            <strong>assinatura digital</strong> para poder ter acesso as
            diversas funcionalidades do nosso sistema.
          </p>
          <br />
          {/* <p>
            Em caso de <strong>dúvidas</strong>, clique no botão abaixo para
            envia-las ao nosso <strong>jurídico</strong>.
          </p> */}
        </div>

        <ButtonContact
          onClick={() => setModalChat(true)}
          newMsg={buttonContact.newMsg}
        >
          {buttonContact.label}
        </ButtonContact>
      </div>

      <ChatAssincrono
        handleOpen={modalChat}
        handleCLose={handleCloseModalChat}
        idInteracao="JURIDICO"
      />
    </div>
  );
};

export default AguardandoAssinatura;
